import React, { useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { Paper, Typography } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ReactPlayer from 'react-player';

import phishLogo from './BrandImages/phishLogo.png';
import Slide1 from './CarouselImages/Slide1.png';
import Slide2 from './CarouselImages/Slide2.png';
import Slide3 from './CarouselImages/Slide3.png';
import Slide4 from './CarouselImages/Slide4.png';
import Slide5 from './CarouselImages/Slide5.png';
import Chrome from './ExtensionImages/Chrome.png';
import Firefox from './ExtensionImages/Firefox.png';
import Edge from './ExtensionImages/Edge.png';

const NewUserLandingPage = () => {
  const images = [Slide1, Slide2, Slide3, Slide4, Slide5];
  // Slide 0 = YouTube intro; slides 1..n = static images.
  const slideCount = 1 + images.length;
  const [activeIndex, setActiveIndex] = useState(0);
  const reactPlayerRef = useRef();
  const fallbackImage = 'https://via.placeholder.com/60x40?text=Fallback';

  const goTo = (index) => {
    const next = ((index % slideCount) + slideCount) % slideCount;
    setActiveIndex(next);
  };

  const thumbnailSrc = (index) =>
    index === 0
      ? 'https://img.youtube.com/vi/PpyBXM6-r_s/hqdefault.jpg'
      : images[index - 1] || fallbackImage;

  return (
    <div style={{ backgroundColor: '#f5f7fa', minHeight: '100vh', padding: '20px 0' }}>
      <style>
        {`
          .carousel-container {
            max-width: 900px;
            margin: 0 auto;
            padding: 20px;
            position: relative;
          }
          .carousel-stage {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 560px;
            max-width: 100%;
            height: 350px;
            margin: 0 auto;
            overflow: hidden;
          }
          .carousel-stage .react-youtube-container iframe,
          .carousel-stage iframe {
            width: 560px !important;
            height: 350px !important;
            min-height: 350px !important;
            min-width: 560px !important;
            max-width: 100%;
          }
          .carousel-stage img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            margin: 0;
          }
          .carousel-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            background: #1976d2 !important;
            color: white !important;
          }
          .carousel-nav-left { left: 10px; }
          .carousel-nav-right { right: 10px; }
          .carousel-nav:hover { background: #1565c0 !important; }
          .custom-dot-list-style {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            padding: 0;
            list-style: none;
            flex-wrap: wrap;
            gap: 8px;
          }
          .MuiPaper-root {
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }
          #extensionButtons {
            margin-top: 40px;
          }
          #extensionButtons .MuiButton-root {
            background: #061739;
            color: white;
            border-radius: 8px;
            padding: 10px 20px;
            transition: transform 0.2s, box-shadow 0.2s;
          }
          #extensionButtons .MuiButton-root:hover {
            background: #040d26;
            transform: translateY(-2px);
            box-shadow: 0 6px 12px rgba(6, 23, 57, 0.3);
          }
          #extensionButtons .MuiButton-root img {
            margin-right: 8px;
          }
          .welcome-text {
            text-align: center;
            margin-bottom: 40px;
            color: #333;
            font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
          }
        `}
      </style>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Typography variant="h4" className="welcome-text">
          Welcome to <img src={phishLogo} alt="PhishCloud Logo" style={{ width: '270px' }} />
        </Typography>
      </div>

      <div className="carousel-container">
        <IconButton
          className="carousel-nav carousel-nav-left"
          onClick={() => goTo(activeIndex - 1)}
          aria-label="Previous slide"
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          className="carousel-nav carousel-nav-right"
          onClick={() => goTo(activeIndex + 1)}
          aria-label="Next slide"
        >
          <ChevronRightIcon />
        </IconButton>

        <div className="carousel-stage">
          {activeIndex === 0 ? (
            <Paper elevation={3}>
              <ReactPlayer
                url={'https://youtu.be/PpyBXM6-r_s'}
                ref={reactPlayerRef}
                className="react-player"
                width="560px"
                height="350px"
                style={{ maxWidth: '1000px', justifyContent: 'center' }}
                controls={true}
              />
            </Paper>
          ) : (
            <Paper elevation={3}>
              <img
                src={images[activeIndex - 1] || fallbackImage}
                alt={`Slide ${activeIndex}`}
                style={{ width: '560px', height: '350px', objectFit: 'cover', maxWidth: '100%' }}
              />
            </Paper>
          )}
        </div>

        <div className="custom-dot-list-style" role="tablist" aria-label="Carousel slides">
          {Array.from({ length: slideCount }).map((_, index) => {
            const active = index === activeIndex;
            return (
              <button
                key={index}
                type="button"
                onClick={() => goTo(index)}
                style={{
                  border: active ? '2px solid #1976d2' : '2px solid transparent',
                  borderRadius: '4px',
                  padding: '2px',
                  background: 'none',
                  cursor: 'pointer',
                }}
                aria-label={`Go to slide ${index + 1}`}
                aria-selected={active}
              >
                <img
                  src={thumbnailSrc(index)}
                  alt={`Thumbnail for slide ${index + 1}`}
                  style={{
                    width: '80px',
                    height: '60px',
                    objectFit: 'cover',
                    borderRadius: '4px',
                    opacity: active ? 1 : 0.7,
                  }}
                />
              </button>
            );
          })}
        </div>
      </div>

      <div
        id="extensionButtons"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: '10px',
        }}
      >
        <Typography variant="body1" className="welcome-text">
          Get started by installing our extension for your browser:
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            flexWrap: 'wrap',
          }}
        >
          <a
            href="https://chromewebstore.google.com/detail/phishcloud/kiiikjhlelilgeljcacimkoaccpljjac"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="contained" color="primary">
              <img src={Chrome} alt="" style={{ padding: '6px' }} />
              Chrome
            </Button>
          </a>
          <a
            href="https://addons.mozilla.org/en-US/firefox/addon/phishcloud/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="contained" color="primary">
              <img src={Firefox} alt="" style={{ padding: '6px' }} />
              Firefox
            </Button>
          </a>
          <a
            href="https://chromewebstore.google.com/detail/phishcloud/kiiikjhlelilgeljcacimkoaccpljjac"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="contained" color="primary">
              <img src={Edge} alt="" style={{ padding: '6px' }} />
              Edge
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewUserLandingPage;
